/* eslint-disable */

import { useEffect, useState } from 'react'
import SubscriptionModal from '../Components/modals/SubscriptionModal'
import MandateDetails from '../Components/modals/MandateDetails'
import MFBreakdown from '../Components/modals/MFBreakdown'
import SellRequestForm from '../Components/modals/SellRequestForm'
import MessagePopup from '../Components/Popups/MessagePopup'
import { ErrorPopup } from '../Components/Popups/ErrorPopup'
import BasketOrderPopup from '../Components/Popups/BasketOrderPopup'
import ActionPlanPopup from '../Components/Popups/ActionPlanPopup'
import PaymentBreakdown from '../Pages/FirstIdeas/PaymentBreakdown'
import AdminPopup from '../Components/Popups/AdminPopups'
import OpenAdminMFBreakdown from '../Components/modals/OpenAdminMFBreakdown'
import SIPPopups from '../Components/Popups/SIPPopups'
import KycPopups from '../Components/Popups/KycPopups'
import MandatePopups from '../Components/Popups/MandatePopups'

const ModalProvider = () => {
  const [isMounted, setIsMounted] = useState(false)

  useEffect(() => {
    setIsMounted(true)
  }, [])

  if (!isMounted) return null

  return (
    <>
      <MessagePopup />
      <SubscriptionModal />
      <MandateDetails />
      <MFBreakdown />
      <OpenAdminMFBreakdown />
      <PaymentBreakdown />
      <SellRequestForm />
      <ErrorPopup />
      <BasketOrderPopup />
      <ActionPlanPopup />
      <AdminPopup />
      <SIPPopups />
      <KycPopups />
      <MandatePopups />
    </>
  )
}

export default ModalProvider
